import React, { useState, useEffect } from 'react';
import {Routes, Route} from 'react-router-dom';
import MainLayout from './components/MainLayout';
import MobileMainLayout from './components/MobileMainLayout';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import MyFlows from './pages/MyFlows';
import MyLeads from './pages/MyLeads';
import Profile from './pages/Profile';
import Login from './pages/Login';
import LogoutPage from "./pages/LogoutPage";
import ForgotPassword from "./pages/ForgotPassword";
import MobileLogin from "./pages/MobileLogin";
import MobileForgotPassword from "./pages/MobileForgotPassword";
import { NotificationsProvider } from './context/NotificationsContext';
import MobileMyFlows from "./pages/MobileMyFlows";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Используем MobileMainLayout для мобильных устройств, MainLayout для десктопа
  const MainLayoutComponent = isMobile ? MobileMainLayout : MainLayout;
  const LoginContent = isMobile ? MobileLogin : Login;
  const ForgotPasswordContent = isMobile ? MobileForgotPassword : ForgotPassword;
  const AdvertisersFlowsContent = isMobile ? MobileMyFlows : MyFlows;

  return (
      <NotificationsProvider>
        <MainLayoutComponent>
            <Routes>
                <Route path="/login" element={<LoginContent />} />
                <Route path="/forgot-password" element={<ForgotPasswordContent />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <MyFlows />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/logout"
                  element={
                    <ProtectedRoute>
                      <LogoutPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-flows"
                  element={
                    <ProtectedRoute>
                      <AdvertisersFlowsContent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-leads"
                  element={
                    <ProtectedRoute>
                      <MyLeads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<ProtectedRoute redirectDefault={true} />} />
            </Routes>
        </MainLayoutComponent>
      </NotificationsProvider>
  );
}

export default App;
